var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('buildings'),(!_vm.hideInfo)?_c('info-popup',{on:{"cancel":function($event){_vm.hideInfo=true}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }